import { useCentralApi, useCurrentUser } from "hooks/shared";

const useDeleteNote = (soft?: boolean) => {
    const user = useCurrentUser();
    const fetcher = useCentralApi(user);

    const handleDelete = async (noteId: number) => {
        if (soft ?? true) {
            const resp = await fetcher(`/api/v3/notes/${noteId}/delete`, {
                method: 'PATCH'
            });
        } else {
            const resp = await fetcher(`/api/v3/notes/${noteId}`, {
                method: 'DELETE'
            });
        }
    };

    return handleDelete;
};

export default useDeleteNote;